export const setStepValidity = stepsValidity => ({
  type: 'SET_STEPBOX_ERRORS',
  stepsValidity
})

export const showStepBoxErrors = showErrors => ({
  type: 'SHOW_STEPBOX_ERRORS',
  showErrors
})
